import { Component, Input, OnInit } from '@angular/core';
import { FitAndProperQuestion } from '../../../models/fit-and-proper-question.model';

@Component({
    selector: 'app-fit-and-proper-section',
    templateUrl: './fit-and-proper-section.component.html',
    styleUrls: ['./fit-and-proper-section.component.scss'],
    standalone: false
})
export class FitAndProperSectionComponent implements OnInit {
  @Input() fitAndProperQuestionnaire: FitAndProperQuestion[] = [];

  ngOnInit(): void {
  }
}